<template>
  <a-form-item :label="label">
    <a-select
      v-model:value="selectValue"
      placeholder="请选择"
      :show-search="showSearch"
      :allowClear="true"
      :mode="mode"
      :disabled="disabled"
      option-filter-prop="children"
      :filter-option="filterOption || filterProp"
    >
      <slot></slot>
    </a-select>
  </a-form-item>
</template>
<script>
import { reactive, toRefs, watch } from 'vue'
export default {
  props: {
    value: [String, Number]
  },
  emits: ['update:value'],
  setup(props, context) {
    const { emit, attrs } = context
    const state = reactive({
      ...attrs,
      ...{
        selectValue: props.value
      },
      filterProp(input, option) {
        return (
          option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      }
    })
    watch(
      () => props.value,
      val => {
        state.selectValue = val
      }
    )
    watch(
      () => state.selectValue,
      val => {
        emit('update:value', val)
      }
    )

    return {
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped></style>
